import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import {
  SortableElement,
} from 'react-sortable-hoc';

// Components
import { Toggle } from '@zola/zola-ui';
import DragHandle from '../../../../common/ui/DragHandle';

const RsvpListItem = SortableElement(({
  rsvp,
  onEdit,
  updateEvent,
}) => {
  const numGuestsInvited = rsvp.num_guests_attending + rsvp.num_guests_declined + rsvp.num_guests_not_responded;
  const trimmedRsvpName = rsvp.name > 30 ? `${rsvp.name.slice(0, 30)}...` : rsvp.name;
  const isOnlineRsvpOn = rsvp.collect_rsvps;
  const toggleLabel = isOnlineRsvpOn ? 'Online RSVP On' : 'Online RSVP Off';

  return (
    <li className="list-item__sortable event">
      <DragHandle />
      <div className="event__details">
        <h4 className="event__title-section">
          <span  className="event__title">{trimmedRsvpName}</span>
          <span className="event__edit-btn" onClick={() => onEdit(rsvp)}>Edit</span>
        </h4>
        <div className="event__rsvp-info">
          <Toggle
            input={{
              value: isOnlineRsvpOn,
              onChange: () => updateEvent({...rsvp, collect_rsvps: !isOnlineRsvpOn}),
            }}
            label={toggleLabel}
            labelSide="right"
            className="event__toggle-rsvp"
          />
        </div>
        <div className="event__guests-info">
          <span className={`event__guests-invited ${numGuestsInvited < 1 ? 'no-guests-invited' : ''}`}>
            {numGuestsInvited} {numGuestsInvited === 1 ? 'guest' : 'guests'} invited
          </span>
          <Link className="event__manage-guests-link zola-ui link link-arrow" to="/wedding/manage/guests/build">
            Manage Guests
          </Link>
        </div>
      </div>
    </li>
  );
});

RsvpListItem.propTypes = {
  rsvp: PropTypes.shape({}).isRequired,
  onEdit: PropTypes.func.isRequired,
  updateEvent: PropTypes.func.isRequired,
};

RsvpListItem.defaultProps = {
  rsvp: {
    name: '',
    num_guests_attending: 0,
    num_guests_declined: 0,
    num_guests_not_responded: 0,
  }
};

export default RsvpListItem;



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/Rsvp/RsvpListItemV2.jsx